import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Slide21Final() {
  return <div className="flex flex-col h-full max-w-[1200px] mx-auto w-full justify-center text-center" data-id="element-569">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.2
    }} className="mb-12" data-id="element-570">
        <h2 className="text-5xl font-display font-bold text-slate-900 mb-8 leading-tight" data-id="element-571">
          Make this a <span className="text-minerva-blue" data-id="element-572">repeatable</span>{' '}
          market-listening platform
        </h2>

        <p className="text-xl text-slate-600 leading-relaxed mb-8" data-id="element-573">
          The SNMMI Snak™ proved that a specialist company can use a short
          interactive format to create engagement, capture high-quality leads,
          and learn what the market cares about.
        </p>
        <p className="text-xl text-slate-600 leading-relaxed mb-16" data-id="element-574">
          The next step is to turn that into a repeatable loop: use the SNMMI
          findings as the hook, improve booth activation, capture the next wave
          of insight, and build Minerva's position as a company that understands
          where radiopharma development is heading.
        </p>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.9
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.6
    }} className="relative bg-minerva-dark text-white rounded-3xl p-10 border border-minerva-blue/20 shadow-xl" data-id="element-575">
        <div className="absolute -top-6 left-1/2 -translate-x-1/2 bg-white p-3 rounded-full border border-slate-200 shadow-sm text-minerva-blue" data-id="element-576">
          <Quote className="w-8 h-8" data-id="element-577" />
        </div>
        <p className="text-3xl font-display font-bold text-white italic mt-4" data-id="element-578">
          "The next congress should not start from zero. It should start from
          what the market already told Minerva at SNMMI."
        </p>
      </motion.div>
    </div>;
}